import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const dashboardText: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'dsgnsys_DashboardText_dataBinding_panelTitle',
    helpId: '5495ddc4-9f61-44e4-8fb8-4ccb8879efec',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'DashboardTextRole',
      bindings: [
        {
          title: 'dsgnsys_DashboardText_dataBinding_text_label',
          prop: 'text',
          supportedFieldTypes: [
            FieldType.text,
            FieldType.richText,
            FieldType.email,
          ],
          defaultFieldType: FieldType.text,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
